"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortOrder = exports.SortBy = exports.SecondaryInfoDisplay = exports.ScoreDisplayFormat = exports.OutcomeArrangement = exports.NameDisplayFormat = exports.DisplayFilter = exports.COLUMN_WIDTH = exports.CELL_HEIGHT = void 0;
var COLUMN_WIDTH = exports.COLUMN_WIDTH = 160;
var CELL_HEIGHT = exports.CELL_HEIGHT = 48;
var SortOrder = exports.SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
  return SortOrder;
}({});
var SortBy = exports.SortBy = /*#__PURE__*/function (SortBy) {
  SortBy["Outcome"] = "outcome";
  return SortBy;
}({});
var SecondaryInfoDisplay = exports.SecondaryInfoDisplay = /*#__PURE__*/function (SecondaryInfoDisplay) {
  SecondaryInfoDisplay["NONE"] = "none";
  SecondaryInfoDisplay["SIS_ID"] = "sis_id";
  SecondaryInfoDisplay["INTEGRATION_ID"] = "integration_id";
  SecondaryInfoDisplay["LOGIN_ID"] = "login_id";
  return SecondaryInfoDisplay;
}({});
var DisplayFilter = exports.DisplayFilter = /*#__PURE__*/function (DisplayFilter) {
  DisplayFilter["SHOW_UNPUBLISHED_ASSIGNMENTS"] = "show_unpublished_assignments";
  DisplayFilter["SHOW_STUDENTS_WITH_NO_RESULTS"] = "show_students_with_no_results";
  DisplayFilter["SHOW_OUTCOMES_WITH_NO_RESULTS"] = "show_outcomes_with_no_results";
  DisplayFilter["SHOW_STUDENT_AVATARS"] = "show_student_avatars";
  return DisplayFilter;
}({});
var NameDisplayFormat = exports.NameDisplayFormat = /*#__PURE__*/function (NameDisplayFormat) {
  NameDisplayFormat["FIRST_LAST"] = "first_last";
  NameDisplayFormat["LAST_FIRST"] = "last_first";
  return NameDisplayFormat;
}({});
var ScoreDisplayFormat = exports.ScoreDisplayFormat = /*#__PURE__*/function (ScoreDisplayFormat) {
  ScoreDisplayFormat["ICON_ONLY"] = "icon_only";
  ScoreDisplayFormat["ICON_AND_POINTS"] = "icon_and_points";
  ScoreDisplayFormat["ICON_AND_LABEL"] = "icon_and_label";
  ScoreDisplayFormat["PERCENT"] = "percent";
  ScoreDisplayFormat["PERCENT_AND_RATIO"] = "percent_and_ratio";
  return ScoreDisplayFormat;
}({});
var OutcomeArrangement = exports.OutcomeArrangement = /*#__PURE__*/function (OutcomeArrangement) {
  OutcomeArrangement["ALPHABETICAL"] = "alphabetical";
  OutcomeArrangement["CUSTOM"] = "custom";
  OutcomeArrangement["UPLOAD_ORDER"] = "upload_order";
  return OutcomeArrangement;
}({});